(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  class OrderTracking extends HTMLElement {
    #controller = null;

    connectedCallback() {
      const params = new URLSearchParams(window.location.search);
      const orderId = params.get('order');
      const token = params.get('t');

      if (!orderId || !token) {
        this.#show('nolink');
        return;
      }
      this.#load(orderId, token);
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }

    async #load(orderId, token) {
      this.#controller?.abort();
      this.#controller = new AbortController();

      const base = this.dataset.endpoint || 'https://invoices.herbcottage.com.au';
      const url = new URL(`/track/${encodeURIComponent(orderId)}/${encodeURIComponent(token)}`, base);

      try {
        const response = await fetch(url, { signal: this.#controller.signal });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        this.#render(await response.json());
        this.#show('ready');
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.#show('error');
      }
    }

    #show(state) {
      for (const el of this.querySelectorAll('[data-state]')) {
        el.hidden = el.dataset.state !== state;
      }
    }

    #field(name) {
      return this.querySelector(`[data-field="${name}"]`);
    }

    #text(name, value) {
      const el = this.#field(name);
      if (el) el.textContent = value ?? '';
    }

    /** Reveal a container only when the worker actually supplied content for it. */
    #reveal(name) {
      const el = this.#field(name);
      if (el) el.hidden = false;
    }

    #bullets(name, points) {
      const el = this.#field(name);
      if (!el) return;
      el.replaceChildren();
      for (const point of points ?? []) {
        const li = document.createElement('li');
        li.textContent = point;
        el.appendChild(li);
      }
    }

    #render(data) {
      this.#text('orderName', `Order ${data.orderName}`);
      this.#text('headline', data.headline);
      this.#text('detail', data.detail);
      this.#renderSteps(data.steps);

      const timing = [];
      if (data.sentOn) timing.push(`Sent ${data.sentOn}`);
      if (data.estimate) timing.push(`usually arrives in ${data.estimate}`);
      if (timing.length) {
        this.#text('estimate', `${timing.join(', ')}.`);
        this.#reveal('estimate');
      }

      if (data.collection) {
        this.#text('outlet', data.collection.outlet || 'Your local post office');
        this.#text('collectBy', data.collection.collectBy ?? '');
        this.#text('collectNote', 'Australia Post send parcels back to us after that.');
        this.#reveal('collection');
      }

      if (data.reassurance) {
        this.#text('reassurance', data.reassurance);
        this.#reveal('reassurance');
      }

      if (data.care) {
        this.#text('careHeading', data.care.heading);
        this.#bullets('carePoints', data.care.points);
        if (data.care.video) this.#setupVideo(data.care.video);
        this.#reveal('careCard');
      }

      if (data.help) {
        this.#text('helpHeading', data.help.heading);
        this.#bullets('helpPoints', data.help.points);
        this.#reveal('helpCard');
      }

      if (data.items?.length) {
        this.#renderItems(data.items);
        this.#reveal('itemsWrap');
      }

      if (data.dispatchNote) {
        this.#text('dispatchNote', data.dispatchNote);
        this.#reveal('dispatchNote');
      }

      if (data.history?.length) {
        this.#renderHistory(data.history);
        this.#reveal('historyWrap');
      }

      this.#renderTracking(data.trackingNumber, data.carrierUrl, data.carrierName);
    }

    /**
     * Inline video, loaded only when opened. A YouTube player is heavy and
     * most people never expand it, so injecting it upfront would cost every
     * visitor for the benefit of a few. nocookie keeps YouTube's tracking
     * out of the page until they choose to watch.
     */
    #setupVideo(video) {
      const wrap = this.#field('videoWrap');
      const frame = this.#field('videoFrame');
      if (!wrap || !frame) return;

      this.#text('videoLabel', video.label);
      wrap.hidden = false;

      wrap.addEventListener('toggle', () => {
        if (!wrap.open || frame.querySelector('iframe')) return;
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(video.youtubeId)}`;
        iframe.title = video.label;
        iframe.loading = 'lazy';
        iframe.allow = 'accelerometer; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        frame.appendChild(iframe);
      });
    }

    #renderSteps(steps) {
      const list = this.#field('steps');
      if (!list) return;
      list.replaceChildren();

      for (const step of steps ?? []) {
        const li = document.createElement('li');
        li.className = 'order-tracking__step';
        if (step.done) li.classList.add('order-tracking__step--done');
        if (step.current) li.classList.add('order-tracking__step--current');
        li.textContent = step.label;
        list.appendChild(li);
      }
    }

    #renderItems(items) {
      const list = this.#field('items');
      if (!list) return;
      list.replaceChildren();

      for (const item of items) {
        const li = document.createElement('li');

        if (item.imageUrl) {
          const img = document.createElement('img');
          img.src = item.imageUrl;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 46;
          img.height = 46;
          li.appendChild(img);
        }

        const name = document.createElement('span');
        name.className = 'order-tracking__item-name';
        name.textContent = item.variantTitle ? `${item.title} · ${item.variantTitle}` : item.title;
        li.appendChild(name);

        const qty = document.createElement('span');
        qty.className = 'order-tracking__item-qty';
        qty.textContent = `×${item.quantity}`;
        li.appendChild(qty);

        list.appendChild(li);
      }
    }

    /**
     * Tracking number + carrier link, shown for every parcel that has a
     * number, not just the ones with a scan list (only Aramex hands us one).
     * The labels are merchant settings carrying a {carrier} placeholder, so an
     * Aramex parcel never says "Australia Post".
     */
    #renderTracking(trackingNumber, carrierUrl, carrierName) {
      if (!trackingNumber) return;
      // Never leave the raw token on screen if the name is somehow missing.
      const name = carrierName || 'the carrier';

      const label = this.#field('trackingLabel');
      if (label) label.textContent = label.textContent.replace('{carrier}', name).trim();
      this.#text('trackingNumber', trackingNumber);
      this.#setupCopy(trackingNumber);

      const link = this.#field('carrierUrl');
      if (link && carrierUrl) {
        link.href = carrierUrl;
        link.textContent = link.textContent
          .replace('{carrier}', name)
          // Also catch the pre-Aug-2026 saved label, which named AusPost literally.
          .replace('Australia Post', name);
      } else if (link) {
        link.hidden = true;
      }

      this.#reveal('trackingWrap');
    }

    /** Copy button only where the browser can actually copy. */
    #setupCopy(trackingNumber) {
      const button = this.#field('copyButton');
      if (!button || !navigator.clipboard?.writeText) return;

      const idleLabel = button.textContent.trim();
      const copiedLabel = button.dataset.copiedLabel || idleLabel;
      let resetTimer = null;

      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(trackingNumber);
        } catch {
          return;
        }
        button.textContent = copiedLabel;
        clearTimeout(resetTimer);
        resetTimer = setTimeout(() => { button.textContent = idleLabel; }, 2000);
      });
      button.hidden = false;
    }

    #renderHistory(history) {
      const list = this.#field('history');
      if (!list) return;
      list.replaceChildren();

      for (const entry of history) {
        const li = document.createElement('li');
        const time = document.createElement('time');
        time.textContent = entry.at;
        li.appendChild(time);

        const label = document.createElement('span');
        label.textContent = entry.label;
        li.appendChild(label);

        list.appendChild(li);
      }
    }
  }

  customElements.define('order-tracking', OrderTracking);

  } catch(e) { console.error(e); }
})();
})();
